import React from 'react';
import {
	Box,
	Button,
	Flex,
	Heading,
	Stack,
	Spacer,
	Tooltip,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { trip } from '../data';
import { makeFields } from './utils';

export const Trip = ({ state, setter, remove, id, onBlur }) => {
	const { country, cities, startDate, endDate, purpose } = makeFields(
		state,
		setter,
		trip,
		onBlur
	);
	return (
		<Box borderRadius="md" border="1px" borderColor="gray.200" p={4} mb={4}>
			<Flex>
				<Heading pb={6} fontSize={'lg'}>
					{state.cities || 'Поездка'}
				</Heading>
				<Spacer />
				<Button
					leftIcon={<CloseIcon />}
					colorScheme="red"
					variant="solid"
					size="xs"
					name={id}
					onClick={remove}
				>
					Удалить
				</Button>
			</Flex>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...country} />
				<ProfileField pb={6} {...purpose} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...cities} />
			</Stack>
			<Tooltip label="Период посещения" placement="top-start">
				<Heading fontSize="lg" pb={6}>
					Visiting term
				</Heading>
			</Tooltip>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...startDate} />
				<ProfileField pb={6} {...endDate} />
			</Stack>
		</Box>
	);
};
